(() => {
  const settings = document.querySelector("script[data-mf-gallery]").dataset;
  const selector = ".mf-bf__slides, .mf-pet__slides";
  let dialog;
  let preview;
  let counter;
  let entries = [];
  let position = 0;
  let trigger;
  let previousOverflow;
  let previousBodyOverflow;
  let previousScrollY = 0;
  const create = (tag, className) => {
    const element = document.createElement(tag);
    element.className = className;
    return element;
  };
  const button = (className, label, symbol) => {
    const element = create("button", className);
    element.type = "button";
    element.setAttribute("aria-label", label);
    element.textContent = symbol;
    return element;
  };
  const render = () => {
    const image = entries[position];
    preview.src = image.src;
    preview.alt = image.alt;
    counter.textContent = String(position + 1) + " " + settings.of + " " + String(entries.length);
  };
  const move = step => {
    position = (position + step + entries.length) % entries.length;
    render();
  };
  const build = () => {
    dialog = create("dialog", "mf-gallery-dialog");
    dialog.setAttribute("aria-label", settings.title);
    const close = button("mf-gallery-dialog__close", settings.close, "×");
    const stage = create("div", "mf-gallery-dialog__stage");
    preview = create("img", "mf-gallery-dialog__image");
    stage.append(preview);
    const controls = create("div", "mf-gallery-dialog__controls");
    const previous = button("", settings.prev, "‹");
    const next = button("", settings.next, "›");
    counter = create("p", "mf-gallery-dialog__status");
    counter.setAttribute("aria-live", "polite");
    controls.append(previous, counter, next);
    dialog.append(close, stage, controls);
    document.body.append(dialog);
    close.addEventListener("click", () => dialog.close());
    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
    dialog.addEventListener("keydown", event => {
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        move(event.key === "ArrowLeft" ? -1 : 1);
      }
    });
    dialog.addEventListener("close", () => {
      document.documentElement.style.overflow = previousOverflow;
      document.body.style.overflow = previousBodyOverflow;
      window.scrollTo(0, previousScrollY);
      if (trigger && trigger.isConnected) trigger.focus({preventScroll: true});
    });
  };
  const open = (gallery, image) => {
    if (!dialog) build();
    entries = Array.from(gallery.querySelectorAll("img"));
    position = entries.indexOf(image);
    if (position < 0) return;
    trigger = image;
    render();
    previousScrollY = window.scrollY;
    previousOverflow = document.documentElement.style.overflow;
    previousBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    dialog.showModal();
    dialog.querySelector("button").focus({preventScroll: true});
  };
  const bind = gallery => {
    if (gallery.hasAttribute("data-mf-lightbox-ready")) return;
    gallery.setAttribute("data-mf-lightbox-ready", "");
    gallery.querySelectorAll("img").forEach((image, index) => {
      image.tabIndex = 0;
      image.setAttribute("role", "button");
      image.setAttribute("aria-haspopup", "dialog");
      image.setAttribute("aria-label", settings.open.replace("[index]", String(index + 1)));
    });
    gallery.addEventListener("click", event => {
      const image = event.target.closest("img");
      if (image && gallery.contains(image)) open(gallery, image);
    });
    gallery.addEventListener("keydown", event => {
      if ((event.key === "Enter" || event.key === " ") && event.target.matches("img")) {
        event.preventDefault();
        open(gallery, event.target);
      }
    });
  };
  document.querySelectorAll(selector).forEach(bind);
  document.addEventListener("shopify:section:load", event => {
    event.target.querySelectorAll(selector).forEach(bind);
  });
})();
